// extracted by mini-css-extract-plugin
module.exports = {"priceRangeInputs":"priceRange_priceRangeInputs__1e_5w","priceRangeSeparator":"priceRange_priceRangeSeparator__3vUuh"};